import { Slider } from "@/components/ui/slider.tsx";
import { ONLY_NUMERIC_REGEX } from "@/constants/regex";

type SliderInputProps = {
  valueSlider: number[];
  onChangeSlider?: (value: number[]) => void;
  valueInput: number;
  onChangeInput?: (value: number) => void;
  max?: number;
  disabled?: boolean;
};

export default function SliderInput(props: Readonly<SliderInputProps>) {
  const {
    valueSlider,
    onChangeSlider,
    valueInput,
    onChangeInput,
    max = 100,
    disabled
  } = props;

  return (
    <div className="flex flex-row w-full gap-2 flex-1">
      <Slider
        value={valueSlider}
        onValueChange={onChangeSlider}
        max={max}
        step={1}
        className="w-full"
        disabled={disabled}
      />
      <input
        type="text"
        inputMode="numeric"
        value={valueInput}
        onChange={(e) => {
          const value = e.target.value.replace(ONLY_NUMERIC_REGEX, "");
          onChangeInput?.(Number(value));
        }}
        onKeyDown={(e) => {
          if (e.key === "ArrowUp" && valueInput < max) {
            onChangeInput?.(valueInput + 1);
          } else if (e.key === "ArrowDown" && valueInput > 0) {
            onChangeInput?.(valueInput - 1);
          }
        }}
        className="flex-grow-0 flex-shrink-1 w-[44px] text-center py-0.5 px-2 border border-gainsboro rounded-md [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none disabled:bg-white-smoke disabled:text-light-gray"
        disabled={disabled}
      />
    </div>
  );
}
